const getExpressionConfiguration = (block, context, type) => {

  if (!["dependencies", "calculation"].includes(type)) {
    throw new Error("Invalid type. Expected 'dependencies' or 'calculation'.");
  }

  const crossConfig = context?.crossData?.[block.service_block_id]?.[block.id];

  return (crossConfig?.[type] ?
    crossConfig[type].reduce((acc, e) => {
      if (e.startsWith("{")) {
        const parsed = JSON.parse(e);
        if (parsed?.original === 'original_expression') {
          return [...acc, ...block[type]]
        }
      }
      return [...acc, e]
    }, []) : block[type])
}

export default getExpressionConfiguration;